import { __assign } from "tslib";
import { StyleSheet, Text, View } from 'react-native';
import React from 'react';
import { PnmacText, PnmacPaper, PnmacUIButton, PnmacTitle } from 'pnmac-universal-components';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { currencyFormatter, percentFormatter } from '../../../utils.js';
import { textStyle } from '../../../v2/theme/index.js';
import colors from '../../../v2/theme/colors.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../../redux/events/events";
import { NACHA_BANKACCOUNT } from '../../../redux/actions/actions.js';
var PaymentCard = function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  var translations = _a.translations,
    props = _a.props,
    paymentValue = _a.paymentValue,
    paymentDue = _a.paymentDue,
    dueDateDisclaimer = _a.dueDateDisclaimer,
    disclaimerFee = _a.disclaimerFee,
    navigation = _a.navigation,
    achExist = _a.achExist,
    layout = _a.layout,
    isInEligible = _a.isInEligible,
    navigateToOTP = _a.navigateToOTP;
  var paymentModel = layout.paymentModel;
  var _q = (layout === null || layout === void 0 ? void 0 : layout.currentLoan) || {
      customerProperty: []
    },
    unpaidPrincipalBalanceAmount = _q.unpaidPrincipalBalanceAmount,
    currentInterestRate = _q.currentInterestRate,
    loanId = _q.loanId;
  var isPendingApplication = ((_b = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments[0]) === null || _b === void 0 ? void 0 : _b.status) ? ((_c = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments[0]) === null || _c === void 0 ? void 0 : _c.status) === 0 || ((_d = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments[0]) === null || _d === void 0 ? void 0 : _d.status) === 201290 || ((_e = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments[0]) === null || _e === void 0 ? void 0 : _e.status) === 1000008 : false;
  return /*#__PURE__*/React.createElement(PnmacPaper, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.contentContainer
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.leftColorBar
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      width: "100%",
      padding: 11.6
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.title
  }, isInEligible ? 'MORTGAGE - ' + (loanId === null || loanId === void 0 ? void 0 : loanId.toString().substr((loanId === null || loanId === void 0 ? void 0 : loanId.length) - 4)) : translations.Payments), !isInEligible && /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.paymentValue
  }, paymentValue), isPendingApplication ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacPaper, {
    style: styles.applicationPendingContainer
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.cardDescriptionTitleText
  }, "AutoPay Application Pending"), /*#__PURE__*/React.createElement(View, {
    style: {
      height: 8
    }
  }), /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.cardDescriptionText
  }, "Please allow 1-5 business days to process"))) : achExist && !isInEligible && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacPaper, {
    style: styles.applicationPendingContainer
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      marginTop: 8.4,
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: "#14882C",
      marginRight: 6
    }
  }), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontFamily: "HalenoirCompactText-Bold",
      fontSize: 12,
      color: "#14882C"
    }
  }, "AutoPay Enabled")), /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.cardDescriptionText
  }, "".concat(((_g = (_f = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _f === void 0 ? void 0 : _f.bankAccount) === null || _g === void 0 ? void 0 : _g.bankAccountType) === 201286 ? "Checking" : ((_j = (_h = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _h === void 0 ? void 0 : _h.bankAccount) === null || _j === void 0 ? void 0 : _j.bankAccountType) === 201287 ? "Savings" : ((_l = (_k = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _k === void 0 ? void 0 : _k.bankAccount) === null || _l === void 0 ? void 0 : _l.bankAccountType) === 201288 ? "Debit Card" : "Unknown", " "), (_p = (_o = (_m = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _m === void 0 ? void 0 : _m.bankAccount) === null || _o === void 0 ? void 0 : _o.accountNumber) === null || _p === void 0 ? void 0 : _p.replace(/\d(?=\d{4})/g, "*")), /*#__PURE__*/React.createElement(View, {
    style: {
      height: 8
    }
  }), /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.cardDescriptionText
  }, "Next Payment scheduled for ", paymentDue), /*#__PURE__*/React.createElement(PnmacUIButton, {
    marginTop: 14.7,
    style: {
      width: '100%',
      height: 47,
      justifyContent: "center",
      borderWidth: 0,
      backgroundColor: 'white'
    },
    mode: "outlined",
    onPress: function () {
      props.dispatch({
        type: NACHA_BANKACCOUNT,
        paymentModel: __assign(__assign({}, props.layout.paymentModel), {
          selectedView: 'Autopay'
        })
      });
      navigation.navigate("Payment/Ach", {
        edit: true,
        autopayEnabled: true
      });
    }
  }, "Manage Autopay"))), !achExist && !isInEligible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      marginTop: 8.4
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: "#14882C",
      marginRight: 6
    }
  }), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontFamily: "HalenoirCompactText-Bold",
      fontSize: 12,
      color: "#5C5C5C"
    }
  }, "".concat(translations.PaymentDue, " ").concat(paymentDue))), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontFamily: "Halenoir Compact Text W05 Obl",
      fontSize: 12,
      color: "#5C5C5C",
      fontStyle: "italic",
      marginTop: 8.2
    }
  }, translations.PaymentDueDisclaimer.replace("{{date}}", dueDateDisclaimer).replace("{{fee}}", disclaimerFee))), isInEligible && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      fontSize: 12,
      fontStyle: "italic"
    })
  }, translations === null || translations === void 0 ? void 0 : translations.CurrentLoanBalance), /*#__PURE__*/React.createElement(PnmacTitle, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      fontSize: 32,
      fontWeight: "bold",
      marginTop: 11,
      paddingVertical: 4,
      color: colors.primary.darkCyan
    })
  }, currencyFormatter('en-US', 'currency', 'USD', unpaidPrincipalBalanceAmount === null || unpaidPrincipalBalanceAmount === void 0 ? void 0 : unpaidPrincipalBalanceAmount.toString()))), /*#__PURE__*/React.createElement(View, {
    style: {
      width: '90%',
      height: 1,
      marginTop: 20,
      backgroundColor: 'grey'
    }
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      fontSize: 12,
      fontStyle: "italic"
    })
  }, translations === null || translations === void 0 ? void 0 : translations.CurrentInterestRate), /*#__PURE__*/React.createElement(PnmacTitle, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      fontSize: 32,
      fontWeight: "bold",
      marginTop: 10,
      paddingVertical: 4,
      color: colors.primary.green
    })
  }, percentFormatter('en-US', 'percent', currentInterestRate)))), /*#__PURE__*/React.createElement(PnmacUIButton, {
    marginTop: 14.7,
    style: {
      width: '94%',
      height: 47,
      justifyContent: "center",
      marginHorizontal: 6
    },
    mode: achExist ? "outlined" : "contained",
    onPress: function () {
      props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Message-Card-button|Mobile', -1, "", false);
      navigateToOTP();
    }
  }, achExist ? 'Make additional payment' : translations.MakeAPayment))));
};
var styles = StyleSheet.create({
  container: {
    padding: 0,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row"
  },
  leftColorBar: {
    backgroundColor: "#56AC69",
    height: "100%",
    width: 4,
    borderTopLeftRadius: 7,
    borderBottomLeftRadius: 7
  },
  title: {
    fontFamily: "Montserrat-SemiBold",
    fontSize: 11,
    fontWeight: "600",
    color: "#1B1B1B",
    textTransform: "uppercase"
  },
  paymentValue: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 32,
    color: "#117AAA",
    marginTop: 4.4
  },
  applicationPendingContainer: {
    padding: 16,
    paddingLeft: 14.9,
    paddingVertical: 13,
    backgroundColor: "#F8F8F8",
    borderRadius: 7,
    marginHorizontal: 5,
    marginVertical: 5
  },
  cardDescriptionTitleText: {
    fontFamily: "HalenoirCompactText-Bold",
    fontSize: 12,
    color: "#117AAA"
  },
  cardDescriptionText: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 12,
    color: "#5C5C5C"
  }
});
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  var Actions = require("../../../redux/actions/actions.js");
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentCard);